import { render, staticRenderFns } from "./RecommendationList.vue?vue&type=template&id=32aecdbc&scoped=true&"
import script from "./RecommendationList.vue?vue&type=script&lang=js&"
export * from "./RecommendationList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationList.vue?vue&type=style&index=0&id=32aecdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aecdbc",
  null
  
)

/* custom blocks */
import block0 from "./RecommendationList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCheckbox,VCol,VContainer,VFlex,VList,VRow,VSelect,VSwitch})
